module.exports = __webpack_public_path__ + "static/media/br.af9012dc.svg";